import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function SolutionSection() {
  const benefits = ['Bajá la hinchazón', 'Comé sin miedo', 'Sentite más liviana', 'Recuperá el control sobre tu alimentación'];
  return <section className="py-12 sm:py-16 lg:py-20 bg-white" data-id="element-172">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} data-id="element-174">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-playfair font-bold text-brand-text-dark mb-6 leading-tight" data-id="element-175">
            <span className="text-brand-green italic" data-id="element-176">
              Libre de SIBO – Plan de 21 días
            </span>{' '}
            es un sistema completo para empezar a ver cambios reales
          </h2>

          <p className="text-lg text-brand-text-medium mb-12 max-w-2xl mx-auto font-inter" data-id="element-177">
            El problema no sos vos, es no saber qué hacer. Este plan está
            diseñado para ser un sistema claro, organizado y 100% práctico.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 max-w-3xl mx-auto" data-id="element-178">
          {benefits.map((benefit, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-center gap-4 bg-brand-bg-cream p-6 rounded-2xl shadow-sm border border-brand-bg-beige" data-id="element-179">
              <CheckCircle2 className="w-8 h-8 text-brand-green flex-shrink-0" data-id="element-180" />
              <span className="text-lg font-medium text-brand-text-dark text-left" data-id="element-181">
                {benefit}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}